import { render, staticRenderFns } from "./publicCourseDescription.html?vue&type=template&id=65a873a0&scoped=true&"
import script from "./publicCourseDescription.js?vue&type=script&lang=js&"
export * from "./publicCourseDescription.js?vue&type=script&lang=js&"
import style0 from "./publicCourseDescription.scss?vue&type=style&index=0&id=65a873a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a873a0",
  null
  
)

export default component.exports